import { render, staticRenderFns } from "./AddCustomButtonDialog.vue?vue&type=template&id=3081f408"
import script from "./AddCustomButtonDialog.vue?vue&type=script&lang=js"
export * from "./AddCustomButtonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports